import * as React from 'react';
import RootComponent, { Props } from '@websky/core/src/SeatMap/components/SeatMapService/SeatMapService';
import { OrderAdditionalServiceGdsServiceSeat } from '@websky/graphql';
import SeatsInfo from './SeatsInfo/SeatsInfo';

const Gradient = require('javascript-color-gradient');

type SeatPrice = number;

interface SeatMapColors {
	[segmentId: string]: Map<SeatPrice, string>;
}

export const SeatMapColorsContext = React.createContext<SeatMapColors>(null);

const FREE_SEAT_COLOR = '#EFE1D6';
const MAX_PRICE_SEAT_COLOR = '#FAD092';

const SeatMap: React.FC<Props> = props => {
	const colors = React.useMemo(() => {
		const seatMapColors: SeatMapColors = {};

		props.seatMaps?.segments?.forEach(segment => {
			const segmentColors = new Map<SeatPrice, string>();
			let maxPrice = 0;

			segment.decks[0]?.rows?.forEach(row => {
				row.seats.forEach(seat => {
					if (seat.isAvailable && seat.price && seat.price.amount > 0) {
						if (seat.price.amount > maxPrice) {
							maxPrice = seat.price.amount;
						}

						segmentColors.set(seat.price.amount, null);
					}
				});
			});

			segmentColors.delete(maxPrice);

			const colors: string[] = new Gradient()
				.setColorGradient('#4FCDA0', '#F0C1D5')
				.setMidpoint(segmentColors.size)
				.getColors();

			segmentColors.forEach((value, key) => {
				segmentColors.set(key, colors.pop());
			});

			segmentColors.set(0, FREE_SEAT_COLOR);
			segmentColors.set(maxPrice, MAX_PRICE_SEAT_COLOR);

			seatMapColors[segment.segmentsInfo.id] = segmentColors;
		});

		return seatMapColors;
	}, [props.seatMaps]);

	const renderSeatsInfo = (services: OrderAdditionalServiceGdsServiceSeat[]) => {
		return <SeatsInfo seatsInfo={services as any} />;
	};

	return (
		<SeatMapColorsContext.Provider value={colors}>
			<RootComponent {...props} renderSeatsInfo={renderSeatsInfo} />
		</SeatMapColorsContext.Provider>
	);
};

export default SeatMap;
